module.exports = __webpack_public_path__ + "img/tu1_83a1fa62c.png";